import React from "react";
import { Box, InputLabel, ThemeProvider, createTheme } from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";
import { colors } from "../../common/pallette/colors";

const DateSelector = (props:any) => {
    const { variant, label, dateValue, manageChange, disabled, isError, errorMessage } = props;
    
    const theme = createTheme({
        components:{
            MuiInput: {
                styleOverrides: {
                    input: {
                        height: 'auto',
                        fontSize: '12px'
                    }
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        padding: 0,
                    }
                }
            },
            MuiStack: {
                styleOverrides: {
                    root: {
                        paddingTop: '0px !important'
                    }
                }
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        fontSize: '20px !important',
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: colors.black.dark,
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: colors.black.dark,
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: colors.black.dark,
                        },
                        fontSize: '13px',
                        cursor: disabled ? 'not-allowed' : 'text',
                    },
                    input: {
                        cursor: disabled ? 'not-allowed' : 'text',
                    }
                }
            }
        }
    });

    return(
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box sx={{ width: '100%' }}>
                {(label && label !== '')  && <InputLabel className='selectBoxLabel'>{label}</InputLabel>}
                <DatePicker label=""
                onChange={(newValue) => {
                    manageChange(newValue ? newValue : null);
                }}
                value={dateValue ? dayjs(dateValue) : null}
                format="YYYY-MM-DD"
                readOnly={disabled}
                slotProps={{
                textField: {
                    variant: variant ? variant : 'outlined',
                    size: 'small',
                    fullWidth: true,
                    error: isError,
                    disabled: disabled,
                    helperText: isError ? errorMessage : '',
                }
                }}
                />
                </Box>
            </LocalizationProvider>
        </ThemeProvider>
    )
}

export default DateSelector;